<template>
  <soha-page-loading v-if="loading" />
  <div v-else>
    <div
      class="card card-custom gutter-b example example-compact px-8 pt-8 pb-0 mb-2"
    >
      <h4 class="soha-page-title mb-6">
        {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
      </h4>
      <div class="col-lg-12">
        <soha-tab :tabs="tabs" @onClick="changeTab" />
      </div>
    </div>
    <div class="card card-custom gutter-b example example-compact p-8">
      <div>
        <b-tabs nav-class="d-none" v-model="tabIndex">
          <b-tab lazy active>
            <soha-no-access
              v-if="accessSms"
              :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)"
            />
            <div v-else>
              <div class="row m-0 justify-content-between align-items-center">
                <div class="col-lg-6 col-md-8 col-sm-8 col-12">
                  <soha-text-field
                    class="w-100"
                    name="searchSms"
                    :placeholder="$t(`${I18nPrefix}SEARCH_RECEIVER`)"
                    v-model="searchSms"
                    icon="search"
                    icon-position="left"
                    icon-cursor
                    icon-color="secondary"
                    type="number"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-12">
                  <soha-button
                    class="w-100"
                    name="getMessages"
                    @click="getMessages(false)"
                    :text="$t(`${I18nPrefix}UPDATE`)"
                  />
                </div>
              </div>
              <div class="col-lg-12 overflow-hidden">
                <soha-page-loading v-if="updateLoading" size="18" />
                <div v-else>
                  <soha-no-data
                    v-if="!messages.length"
                    :message="$t(`${I18nPrefix}NO_SMS`)"
                  />
                  <div v-else>
                    <soha-timeline>
                      <soha-timeline-item
                        v-for="message in messages"
                        :key="message.id"
                      >
                        <div class="row align-items-center">
                          <span
                            class="svg svg-icon svg-icon-primary svg-icon-2x"
                          >
                            <inline-svg src="/media/svg/soha/icons/mail.svg" />
                          </span>
                          <span class="soha-user-name">
                            {{ message.receptor }}
                          </span>
                          <span class="px-2 soha-date-time">
                            {{ getJalaliTime(message.created_at) }}
                          </span>
                          <span class="px-2 soha-message-status">
                            {{ message.status }}
                          </span>
                          <span
                            class="svg svg-icon svg-icon-primary cursor-pointer"
                            v-b-tooltip.hover="{
                              customClass: 'soha-tooltip-class',
                            }"
                            :title="
                              $t(`${I18nPrefix}SEND_COST`, {
                                cost: toPersianDigits(message.cost),
                              })
                            "
                          >
                            <inline-svg
                              src="/media/svg/soha/icons/circle-dollar.svg"
                            />
                          </span>
                        </div>
                        <div class="row">
                          <div
                            class="soha-text-template"
                            style="border-radius: 0.385rem 0 5px 5px"
                            v-html="message.text"
                          />
                        </div>
                      </soha-timeline-item>
                    </soha-timeline>
                    <div class="mt-5">
                      <b-pagination
                        v-if="totalSMS > perSMSPage"
                        v-model="currentPage"
                        @input="goToSMSPage"
                        :total-rows="totalSMS"
                        :per-page="perSMSPage"
                        align="center"
                        pills
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab lazy>
            <div>
              <div class="row m-0 justify-content-between align-items-center">
                <div class="col-lg-6 col-md-8 col-sm-8 col-12">
                  <soha-text-field
                    name="searchEmail"
                    :placeholder="$t(`${I18nPrefix}SEARCH_RECEIVER`)"
                    class="w-100"
                    v-model="searchEmail"
                    icon="search"
                    icon-position="left"
                    icon-cursor
                    icon-color="secondary"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-12">
                  <soha-button
                    class="w-100"
                    name="getEmails"
                    @click="getEmails(true)"
                    :text="$t(`${I18nPrefix}UPDATE`)"
                  />
                </div>
              </div>
              <soha-no-data
                v-if="!emails.length"
                :message="$t(`${I18nPrefix}NO_EMAIL`)"
              />
              <div class="col-lg-12 overflow-hidden" v-else>
                <soha-page-loading v-if="updateLoading" size="18" />
                <div v-else>
                  <soha-timeline>
                    <soha-timeline-item v-for="email in emails" :key="email.id">
                      <div class="row align-items-center">
                        <span class="svg svg-icon svg-icon-primary svg-icon-2x">
                          <inline-svg src="/media/svg/soha/icons/mail.svg" />
                        </span>
                        <span class="soha-user-name">{{ email.receptor }}</span>
                        <span class="p-2 soha-date-time">
                          {{ getJalaliTime(email.created_at) }}
                        </span>
                        <span class="p-2 soha-message-status">
                          {{
                            email.messageId
                              ? $t(`${I18nPrefix}SENT`)
                              : $t(`${I18nPrefix}TIMING`)
                          }}
                        </span>
                      </div>
                      <div class="row">
                        <div
                          class="soha-text-template"
                          style="border-radius: 0.385rem 0 5px 5px"
                          v-html="email.text"
                        />
                      </div>
                    </soha-timeline-item>
                  </soha-timeline>
                  <div class="mt-5">
                    <b-pagination
                      v-if="totalEmails > perEmailPage"
                      v-model="currentPage"
                      @input="goToEmailPage"
                      :total-rows="totalEmails"
                      :per-page="perEmailPage"
                      align="center"
                      pills
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";
import { mapGetters } from "vuex";
export default {
  name: "MessageInfo",

  mixins: [UIMixin],

  data() {
    return {
      I18nPrefix: "PAGES.REPORT.MESSAGE.",
      loading: false,
      accessSms: null,
      messages: [],
      searchEmail: "",
      searchSms: "",
      updateLoading: false,
      tabIndex: 0,
      emails: [],
      noEmail: null,
      interVal: null,
      currentPage: null,
      tabs: [
        {
          title: this.$t(`PAGES.REPORT.MESSAGE.SMS`),
        },
        {
          title: this.$t(`PAGES.REPORT.MESSAGE.EMAIL`),
        },
      ],
      totalEmails: null,
      perEmailPage: null,
      totalSMS: null,
      perSMSPage: null,
    };
  },

  mounted() {
    this.currentPage = this.$route.query.page ?? 1;
    this.getMessages(true);
    this.getEmails();
  },

  methods: {
    getMessages(loading) {
      loading ? (this.loading = true) : (this.updateLoading = true);
      ApiService.get(`api/v2/companies/${this.companyId}/messages`, {
        perPage: "10",
        receptor: this.searchSms,
        page: this.currentPage,
      }).then((response) => {
        if (response.data.code == 403) {
          this.accessSms = response.data.message;
        } else if (response.data.code == 500) {
          this.errorToast(response.data.message);
        } else {
          this.messages = response.data.data;
          this.totalSMS = response.data.total;
          this.perSMSPage = response.data.per_page;
        }
        this.updateLoading = false;
        this.loading = false;
      });
    },

    getEmails(loading) {
      this.updateLoading = loading;
      this.axios
        .post("api/employer/getSentEmailInfo", {
          companyId: this.companyId,
          perPage: "10",
          receptor: this.searchEmail,
          page: this.currentPage,
        })
        .then((response) => {
          if (response.data.code == 500) {
            this.errorToast(response.data.message);
          } else {
            this.emails = response.data.data;
            this.totalEmails = response.data.total;
            this.perEmailPage = response.data.per_page;
          }
          this.updateLoading = false;
        });
    },

    changeTab(index) {
      this.currentPage = 1;
      this.$router.push({ query: { page: this.currentPage } });
      if (index == 0) this.getMessages();
      if (index == 1) this.getEmails(true);
      this.tabIndex = index;
    },

    getJalaliTime(date) {
      return this.toPersianDigits(
        this.$moment(new Date(date)).format("dddd DD jMMMM YYYY HH:mm")
      );
    },

    goToEmailPage() {
      this.$router.push({ query: { page: this.currentPage } });
      this.getEmails(true);
    },

    goToSMSPage() {
      this.$router.push({ query: { page: this.currentPage } });
      this.getMessages();
    },
  },

  computed: {
    ...mapGetters(["companyId"]),
  },

  watch: {
    searchSms() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.currentPage = 1;
      this.interval = setInterval(() => {
        this.getMessages();
        clearInterval(this.interval);
      }, 1000);
    },

    searchEmail() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.currentPage = 1;
      this.interval = setInterval(() => {
        this.getEmails(true);
        clearInterval(this.interval);
      }, 1000);
    },
  },
};
</script>

<style scoped>
.soha-user-name {
  color: var(--primary-color);
  font-weight: bolder;
  padding: 0 0.769rem;
  border-left: 0.231rem solid var(--box-border-light-color);
}
.soha-date-time {
  color: var(--muted-color);
  font-size: 1.077rem;
  border-left: 0.231rem solid var(--box-border-light-color);
}
.soha-message-status {
  color: var(--muted-color);
  font-size: 1.077rem;
}
.soha-text-template {
  margin: 1.538rem;
  padding: 1.154rem;
  background: var(--muted-background-color);
  border: 0.077rem solid var(--box-border-light-color);
  width: 100%;
}
</style>
